import { PaymentGateway } from "../../payment";
import { paymentGatewayBehaviours } from "./paymentGateways/behaviours";

export const cardVerification = {
    isSupported: (paymentGateway: PaymentGateway) =>
        !!paymentGatewayBehaviours[paymentGateway].cardVerificationSupported,
};
